import { createContext, ReactNode } from 'react';

export type InteractionContextType = {
  mode: 'edit' | 'view';
  onPlusIconClick?: (data: { parentNodeId: string }) => void;
  onNodeExpansion?: (data: { nodeId: string; isExpanded: boolean }) => void;
};

export const InteractionContext = createContext<InteractionContextType>({
  mode: 'view',
  onPlusIconClick: () => {},
  onNodeExpansion: () => {},
});

export const InteractionProvider = ({
  mode,
  onPlusIconClick,
  onNodeExpansion,
  children,
}: InteractionContextType & { children: ReactNode }) => {
  return (
    <InteractionContext.Provider value={{ mode, onPlusIconClick, onNodeExpansion }}>
      {children}
    </InteractionContext.Provider>
  );
};
